import { useEffect, useRef, useState } from "react";

interface ITimer {
  timer: number;
  startTimer: (time: number) => void;
  stopTimer: () => void;
}

const useCountDown = (): ITimer => {
  const [timer, setTimer] = useState(0);
  const intervalRef = useRef<NodeJS.Timer>();

  const stopTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const startTimer = (time: number) => {
    setTimer(time);
  };

  useEffect(() => {
    if (timer <= 0) return stopTimer();
    intervalRef.current = setInterval(() => {
      setTimer((t) => t - 1);
    }, 1000);
    return stopTimer;
  }, [timer]);

  return { timer, startTimer, stopTimer };
};

export default useCountDown;
